import React from 'react'
import { Card } from 'primereact/card'
import { renderField } from '../field-registry'

export const CrudDinamicoForm = (props) => {
  const { record, definicao, history, setField } = props
  const campos = (definicao && definicao.campos) || []
  const somenteLeitura = !!record.somenteLeitura
  const modoNovo = !record.oid

  const onChangeCampo = (campo) => (valor) => {
    if (campo.tipo === 'lookup') {
      setField(campo.nome, valor ? valor.oid : null)
      setField(`${campo.nome}__descricao`, valor ? valor.descricao : '')
      return
    }
    setField(campo.nome, valor)
  }

  const titulo = (definicao && definicao.tituloForm) || ''

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card title={`${titulo} ${record.oid || ''}`}>
          {campos
            .filter((campo) => campo.formulario !== false)
            .filter((campo) => campo.editavel || !modoNovo)
            .map((campo) => (
              <div className="p-grid form-group" key={campo.nome}>
                <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
                  {renderField(campo.tipo, {
                    campo,
                    value: record[campo.nome],
                    lookupValue: {
                      oid: record[campo.nome] || '',
                      descricao: record[`${campo.nome}__descricao`] || '',
                    },
                    history,
                    disabled: somenteLeitura || (!campo.editavel && !modoNovo),
                    onChange: onChangeCampo(campo),
                  })}
                </div>
              </div>
            ))}
        </Card>
      </div>
    </div>
  )
}
